/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    $('.js-recover-password').on('click', function(e){
      e.preventDefault();
      $('#login').hide();
      $('#recover').show();
      $('.customers-login #template-customers-login .account-page__header .account__title').text('Reset Password');
      $('.customers-login #template-customers-login .account-page__header .subtitle').html(`Don’t worry we will send you an email to reset your password`);
    });

    $('.cancel-recover-password').on('click', function(e){
      e.preventDefault();
      $('#recover').hide();
      $('#login').show();
      $('.customers-login #template-customers-login .account-page__header .account__title').text('Login');
      $('.customers-login #template-customers-login .account-page__header .subtitle').html(`Don’t have an account? <a href="/account/register" id="customer_register_link">Create an account</a>`);
    })

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;